import $ from "jquery";

// トップへ戻るボタン
const toTop = $('#js-toTop');
toTop.hide()
//スクロールが100に達したらボタン表示
$(window).scroll(function () {
  let scroll = $(window).scrollTop();
  if(scroll > 100) {
    toTop.fadeIn();
    toTop.addClass('-active');
  } else {
    toTop.fadeOut();
    toTop.removeClass('-active');
  }

  let windowHeight = window.innerHeight;
  let footerPosition =  $('#js-footerInner').offset().top;
  if(scroll + windowHeight >= (footerPosition + 45)) {
    let position = (scroll + windowHeight) - footerPosition - 45;
    toTop.css('bottom',position);
  } else {
    if(toTop.hasClass('-active')){
      toTop.css('bottom', '20px');
    }
  }
});
